export enum UserType {
    CUSTOMER = '1',
    COMPANY = '2',
}